var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "3" } },
            [_c("b-list-group", [_c("Menu")], 1)],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                { staticClass: "border" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [_c("h4", [_vm._v(":: Clientes por marcas")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "justify-content-md-center" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "10" } },
                            [
                              _c("h2", [_vm._v("Registro de ")]),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                {
                                  attrs: { id: "register" },
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.onSubmit.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "field_first_name",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Nombres"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group",
                                          class: {
                                            "has-error": _vm.errors.has(
                                              "first_name"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              id: "first_name",
                                              state: _vm.state,
                                              name: "first_name"
                                            },
                                            model: {
                                              value: _vm.register.first_name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.register,
                                                  "first_name",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "register.first_name"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "first_name"
                                                  ),
                                                  expression:
                                                    "errors.has('first_name')"
                                                }
                                              ],
                                              staticClass: "help is-danger"
                                            },
                                            [
                                              _vm._v(
                                                "El campo nombres es requerido"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "field_last_name",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Apellidos"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group",
                                          class: {
                                            "has-error": _vm.errors.has(
                                              "last_name"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              id: "last_name",
                                              state: _vm.state,
                                              name: "last_name"
                                            },
                                            model: {
                                              value: _vm.register.last_name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.register,
                                                  "last_name",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "register.last_name"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "last_name"
                                                  ),
                                                  expression:
                                                    "errors.has('last_name')"
                                                }
                                              ],
                                              staticClass: "help is-danger"
                                            },
                                            [
                                              _vm._v(
                                                "El campo apellidos es requerido"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "fieldsetHorizontal1",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Correo electrónico"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group",
                                          class: {
                                            "has-error": _vm.errors.has("email")
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|email",
                                                expression: "'required|email'"
                                              }
                                            ],
                                            attrs: {
                                              id: "email",
                                              state: _vm.state,
                                              name: "email"
                                            },
                                            model: {
                                              value: _vm.register.email,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.register,
                                                  "email",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "register.email"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "email"
                                                  ),
                                                  expression:
                                                    "errors.has('email')"
                                                }
                                              ],
                                              staticClass: "help is-danger"
                                            },
                                            [
                                              _vm._v(
                                                "El campo correo electrónico es requerido"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "fieldsetHorizontal2a",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Escribir contraseña"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group",
                                          class: {
                                            "has-error": _vm.errors.has(
                                              "password"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  "required|confirmed:confirm_password",
                                                expression:
                                                  "'required|confirmed:confirm_password'"
                                              }
                                            ],
                                            attrs: {
                                              name: "password",
                                              type: "password"
                                            },
                                            model: {
                                              value: _vm.register.password,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.register,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "register.password"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "password"
                                                  ),
                                                  expression:
                                                    "errors.has('password')"
                                                }
                                              ],
                                              staticClass: "help is-danger"
                                            },
                                            [
                                              _vm._v(
                                                "El campo contraseña es requerido"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "fieldsetHorizontal2b",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Repetir contraseña"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group",
                                          class: {
                                            "has-error": _vm.errors.has(
                                              "confirm_password"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  "required|confirmed:password",
                                                expression:
                                                  "'required|confirmed:password'"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              name: "confirm_password",
                                              type: "password"
                                            },
                                            model: {
                                              value:
                                                _vm.register.confirm_password,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.register,
                                                  "confirm_password",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "register.confirm_password"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "password"
                                                  ),
                                                  expression:
                                                    "errors.has('password')"
                                                }
                                              ],
                                              staticClass: "help is-danger"
                                            },
                                            [
                                              _vm._v(
                                                "Debe confirmar la contraseña correctamente"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "fieldsetHorizontal3",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Seleccionar tipo"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group",
                                          class: {
                                            "has-error": _vm.errors.has("role")
                                          }
                                        },
                                        [
                                          _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "mb-3",
                                            attrs: {
                                              state: _vm.state,
                                              options: _vm.options,
                                              name: "role"
                                            },
                                            model: {
                                              value: _vm.register.role,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.register,
                                                  "role",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "register.role"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has("role"),
                                                  expression:
                                                    "errors.has('role')"
                                                }
                                              ],
                                              staticClass: "help is-danger"
                                            },
                                            [
                                              _vm._v(
                                                "Seleccione el tipo de usuario"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "fieldsetHorizontal4",
                                        horizontal: "",
                                        "label-cols": 12,
                                        breakpoint: "md",
                                        label: "Seleccionar Marca(s)"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group container",
                                          class: {
                                            "has-error": _vm.errors.has("brand")
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "row" },
                                            _vm._l(_vm.brands, function(brand) {
                                              return _c(
                                                "div",
                                                {
                                                  key: brand.value,
                                                  staticClass:
                                                    "col-sm-6 check-box-marca"
                                                },
                                                [
                                                  _c("b-form-checkbox", {
                                                    attrs: {
                                                      id: brand.text,
                                                      value: brand.value,
                                                      name: "brand"
                                                    },
                                                    model: {
                                                      value: _vm.items.checks,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.items,
                                                          "checks",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "items.checks"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: { for: "brands" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(brand.value) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.errors, function(
                                        error,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: index },
                                          [
                                            _c(
                                              "b-alert",
                                              { attrs: { show: "" } },
                                              [_vm._v(_vm._s(error.message))]
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "danger"
                                      }
                                    },
                                    [_vm._v("Enviar")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "button",
                                        variant: "success"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.go(-1)
                                        }
                                      }
                                    },
                                    [_vm._v("Cancelar")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bf3755a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf3755a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = null
// module chunks = 